export default __webpack_public_path__ + "static/media/DanskeNarrow.61b0da08.svg";